export default "__VITE_ASSET__ChI5s$1B__"